import React from 'react'

const ShippingInfoContext = React.createContext({
  shippingInfo: {},
  setShippingInfo: () => {},
})

export default ShippingInfoContext
